import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-candidate-hired',
  templateUrl: './activity-item-candidate-hired.component.html',
  styleUrls: ['./activity-item-candidate-hired.component.scss']
})
export class ActivityItemCandidateHiredComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;
  
  @Input()
  language: 'de' | 'en' = 'de';

  // in a candidate's own feed the candidate goes without saying
  @Input()
  context: string = null;

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
